import React from 'react';
import { Drawer } from 'antd';
import styles from './customDrawer.module.scss';
import { BackArrowIcon } from '../../assets';
import DoubleCircleLoader from '../DoubleCircleLoader/Index';

const CustomDrawer = ({
  open,
  onClose,
  closeIcon = <BackArrowIcon />,
  isClosable = true,
  title,
  children,
  showBackdrop = true,
  direction = 'right',
  isBackdropClosable = false,
  getContainer = true, //to render inside the dom tree
  className = '',
  headerStyle,
  customHeader,
  extra,
  isHeader = true,
  destroyOnClose = false,
  customFooter,
  isFooter = true,
  loading = false,
  loadingBackground = false,
}) => {
  return (
    <Drawer
      visible={open}
      onClose={onClose}
      closable={isClosable}
      closeIcon={closeIcon}
      mask={showBackdrop}
      placement={direction}
      title={title}
      headerStyle={customHeader || !isHeader ? { display: 'none' } : headerStyle}
      width={'fit-content'}
      maskClosable={isBackdropClosable}
      getContainer={getContainer}
      className={`${styles.drawer} ${className}`}
      destroyOnClose={destroyOnClose}
    >
      {customHeader && isHeader && (
        <div className={styles.drawerCustomHeaderContainer}>{customHeader}</div>
      )}
      <div className={styles.drawerContent}>{children}</div>
      {customFooter && isFooter && (
        <div className={styles.drawerCustomFooterContainer}>{customFooter}</div>
      )}
      {loading && (
        <div
          className={`${styles.drawerLoadingOverlay} ${
            loadingBackground ? styles.drawerLoadingOverlayWithBackground : ''
          }`}
          role="status"
          aria-label="Loading"
        >
          <DoubleCircleLoader />
        </div>
      )}
    </Drawer>
  );
};

export default CustomDrawer;
